import produce from 'immer'
import { createAsyncObject } from '@jarvis.oddle/core/tools/redux/action'
import { updateForAsyncRequest, updateForAsyncSuccess, updateForAsyncFailure } from '@jarvis.oddle/core/tools/redux/reducer'
import * as CC from '../common/constants'
import * as C from './constants'

export const initialState = createAsyncObject([])

export const reducers = (state = initialState, action) => produce(state, draftState => {
  switch (action.type) {
    case CC.CHANGE_CART_NAME: draftState.fetched = false; break
    case C.GET_ALL_STORES_REQUEST: updateForAsyncRequest(draftState); break
    case C.GET_ALL_STORES_SUCCESS: updateForAsyncSuccess(action.payload.stores)(draftState); break
    case C.GET_ALL_STORES_FAILURE: updateForAsyncFailure(action)(draftState); break
    case C.GET_STORE_INFORMATION_SUCCESS:
      updateForAsyncSuccess((draftState) => {
        try {
          const store = action.payload.stores[0]
          draftState.data = draftState.data.map(
            (currStore) => currStore.id === store.id
              ? ({
                ...currStore,
                earliestCollectionDate: store.earliestCollectionDate,
                earliestCollectionEndTime: store.earliestCollectionEndTime,
                earliestCollectionTime: store.earliestCollectionTime,
                earliestCollectionTimeStamp: store.earliestCollectionTimeStamp
              })
              : currStore
          )
        } catch (error) {
          console.log(`[oddle-shop]: ${error.toString()}`)
        }
      })(draftState)
      break
  }
})
